import React from "react";
import { IoCheckmarkCircleOutline } from "@react-icons/all-files/io5/IoCheckmarkCircleOutline";
import Button from "../../Button";
import { productFilterStyles as styles } from "../styles";
import {
  ProductFilterType,
  useProductFilters
} from "../../../contexts/ProductFilterContext";
import {
  AllProductFilterInterface,
  ProductBrandInterface,
  ProductCategoryInterface
} from "../../../interfaces/product";
import { trackCategoryFilter } from "../../../helpers/trackingEvents";

interface ProductFilterButtonProps {
  filterType: ProductFilterType;
  filter:
    | ProductCategoryInterface
    | ProductBrandInterface
    | AllProductFilterInterface;
}

const ProductFilterButton = ({
  filterType,
  filter: { title, id }
}: ProductFilterButtonProps) => {
  const {
    addFilter,
    removeFilter,
    currentActiveFilters,
    containerRef
  } = useProductFilters();
  const isActive =
    id === "ALL"
      ? currentActiveFilters[filterType].length === 0
      : currentActiveFilters[filterType].includes(id);
  const handleClick = () => {
    trackCategoryFilter(id);
    !isActive
      ? addFilter({
          filterType,
          id
        })
      : removeFilter({
          filterType,
          id
        });
    scrollY > 0 &&
      scrollTo({ top: containerRef?.current?.offsetTop, behavior: "smooth" });
  };

  return (
    <Button
      cssStyles={styles.button}
      type={isActive ? "primary" : "secondary"}
      name={title}
      onClick={handleClick}
      ariaSelected={isActive}
    >
      {title}
      {isActive && <IoCheckmarkCircleOutline css={styles.icon} />}
    </Button>
  );
};

export default ProductFilterButton;
